import { buildPathWithLocale } from '@/lib/i18n/locale-path';
import type { Locale } from 'next-intl';

function isExternalHref(href: string) {
  return (
    href.startsWith('http://') ||
    href.startsWith('https://') ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:') ||
    href.startsWith('#')
  );
}

export function getCmsLocalizedHref(locale: string, href: string) {
  if (isExternalHref(href)) {
    return href;
  }

  return buildPathWithLocale(href, locale as Locale);
}
